var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterestIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.985596,
    width: 38,
    height: 38.0072,
    rx: 8,
    fill: "#E2393F",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 28.9928C23.9706 28.9928 28 24.9617 28 19.9892C28 15.0166 23.9706 10.9856 19 10.9856C14.0294 10.9856 10 15.0166 10 19.9892C10 24.9617 14.0294 28.9928 19 28.9928Z",
    fill: "#E13138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3536 15.806C16.8372 15.806 15.5664 17.5844 15.5664 19.0676C15.5664 19.9676 15.912 20.7632 16.65 21.062C16.7724 21.1124 16.8804 21.0656 16.9164 20.9324C16.9416 20.8424 17.0532 20.6084 17.0784 20.5148C17.1144 20.3852 17.1 20.3384 17.0028 20.2232C16.7904 19.9748 16.6572 19.7156 16.6572 19.262C16.6572 17.75 17.6004 16.6736 19.206 16.6736C20.628 16.6736 21.4092 17.5556 21.4092 18.7004C21.4092 20.2052 20.7324 21.4292 19.728 21.4292C19.1736 21.4292 18.7596 21.026 18.8928 20.4716C19.0512 19.8092 19.3608 19.0964 19.3608 18.6176C19.3608 18.1892 19.1304 17.8832 18.648 17.8832C18.0828 17.8832 17.6256 18.4124 17.6256 19.1864C17.6256 19.6796 17.7876 19.9244 17.7876 19.9244C17.7876 19.9244 17.2152 22.4336 17.1108 22.8584C16.9092 23.7044 17.082 24.7376 17.0964 24.842C17.1036 24.9032 17.1864 24.9176 17.2224 24.8708C17.2728 24.806 17.9496 23.9816 18.18 23.1608C18.2448 22.9304 18.5544 21.728 18.5544 21.728C18.738 22.0736 19.278 22.2968 19.8468 22.2968C21.5496 22.2968 22.7052 20.846 22.7052 18.8012C22.7088 17.2496 21.3768 15.806 19.3536 15.806Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.0072,
    fill: "white",
    transform: "translate(10 10.9856)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestIconSmall);
export default __webpack_public_path__ + "static/media/PinterestIcon_small.1807ba41.svg";
export { ForwardRef as ReactComponent };